const customTheme = require('./src/theme.js')

module.exports = {
  pathPrefix: `/wppapi/spa`,
  siteMetadata: {
    title: `Wisdom`,
    description: `Wisdom App.`,
    author: `no-one`,
    // serviceURL: `https://dev-kbankwpp-api.deepblok.io:8443`, // Dev
    // serviceURL: `https://wisdomlinebcmock.herokuapp.com`, // Dev Mock
    serviceURL: `https://www.thewisdomkasikornbankprivilege.com:8443`
  },
  //
  plugins: [
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `gatsby-starter-default`,
        short_name: `starter`,
        start_url: `/`,
        background_color: `#663399`,
        theme_color: `#663399`,
        display: `minimal-ui`,
        icon: `src/images/gatsby-icon.png`, // This path is relative to the root of the site.
      },
    },
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
    {
      resolve: "gatsby-plugin-antd",
      options: {
        style: true,
      },
    },
    {
      resolve: 'gatsby-plugin-less',
      options: {
        loaderOptions: {
          appendData: `@env: ${process.env.NODE_ENV};`,
        },
        lessOptions: {
          javascriptEnabled: true,
          modifyVars: {
            ...customTheme.antd,
            'carousel-dot-width': '9px',
            'carousel-dot-height': '9px',
            'carousel-dot-active-width': '9px',
            'layout-header-background': customTheme.primaryColor,
            'layout-header-color': '#FFFFFF',
            'layout-header-padding': '4px 50px'
          },
        }
      }
    },
    {
      resolve: `gatsby-plugin-react-redux`,
      options: {
        // [required] - path to your createStore module
        pathToCreateStoreModule: './src/state/store',
        // [optional] - options passed to `serialize-javascript`
        // info: https://github.com/yahoo/serialize-javascript#options
        // will be merged with these defaults:
        serialize: {
          space: 0,
          isJSON: true,
          unsafe: false,
        },
        // [optional] - if true will clean up after itself on the client, default:
        cleanupOnClient: true,
        // [optional] - name of key on `window` where serialized state will be stored, default:
        windowKey: '__PRELOADED_STATE__',
      },
    },
    {
      resolve: 'gatsby-plugin-react-svg',
      options: {
        rule: {
          include: /icons/
        }
      }
    },
  ],
}
